import { Button } from 'components/@tedui';

import type { TopicsRowProps } from './TopicsRow.props';

export function TopicsRow({
  className,
  topics,
  onSelect
}: TopicsRowProps): React.ReactNode {
  return (
    <section className={className}>
      {topics.map(topic => (
        <div key={topic.value} tabIndex={-1}>
          <Button
            text={topic.displayLabel}
            variant="secondary"
            onClick={() => onSelect(topic.value)}
          />
        </div>
      ))}
    </section>
  );
}
